var map = {
	"./dashboard/routes.ts": "./src/router/dashboard/routes.ts",
	"./faturamento/consulta-faturamento/routes.ts": "./src/router/faturamento/consulta-faturamento/routes.ts",
	"./faturamento/relatorio-faturamento/routes.ts": "./src/router/faturamento/relatorio-faturamento/routes.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router sync recursive routes.ts$/";